// URL PRODUCCION
export const URL = "https://www.api.pedidosedificor.com.ar"

//URL LOCAL
//export const URL = "http://192.168.0.2:8080"
